<template>
  <mainContent/>
</template>

<script>
import mainContent from '@/components/_manageroleapprover/main.vue'
export default {
  components: {
    mainContent
  }
}
</script>
